import LoginPage from './LoginPage'
import 'static/style/auth.scss'
export default (LoginPage );